// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2I7BE","header":"MergedInvoice_header__1gICh"};